export const PROFESSIONAL_COUNCILS = [
  { value: 'CRM', label: 'CRM — Conselho Regional de Medicina' },
  { value: 'COREN', label: 'COREN — Conselho Regional de Enfermagem' },
  { value: 'CREFITO', label: 'CREFITO — Conselho Regional de Fisioterapia e Terapia Ocupacional' },
  { value: 'CRF', label: 'CRF — Conselho Regional de Farmácia' },
  { value: 'CRN', label: 'CRN — Conselho Regional de Nutricionistas' },
  { value: 'CRP', label: 'CRP — Conselho Regional de Psicologia' },
  { value: 'CRO', label: 'CRO — Conselho Regional de Odontologia' },
  { value: 'CRBM', label: 'CRBM — Conselho Regional de Biomedicina' },
  { value: 'CRBIO', label: 'CRBIO — Conselho Regional de Biologia' }
]

export const COUNCIL_UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
]

export function councilStamp(source) {
  const code = String(source?.professional_council || source?.professionalCouncil || '').trim().toUpperCase()
  const state = String(source?.professional_council_uf || source?.professionalCouncilUf || '').trim().toUpperCase()
  const number = String(source?.professional_registry || source?.professionalRegistry || '').trim()
  if (!code || !state || !number) return ''
  if (!PROFESSIONAL_COUNCILS.some((item) => item.value === code)) return ''
  if (!COUNCIL_UFS.includes(state)) return ''
  if (!/^[A-Za-z0-9-]{1,20}$/.test(number)) return ''
  return `${code}/${state} ${number}`
}
